
import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const getOrders = async () => {
    const response = await axios.get(`order`, {headers: authHeader()});
    return response.data.result;
}

const getOrder = async (orderId) => {
    const response = await axios.get(`order/${orderId}`, {headers: authHeader()});
    return response.data.result;
};

const getOrderPdf = async (orderId) => {
    const response = await axios.get(`order/${orderId}`, {headers: authHeader()});
    return response.data.result?.taxCertPdf;
};

export const orderApi = {
    getOrders,
    getOrder,
    getOrderPdf
}
